export const GRADES = 'Trin';
export const ALL_GRADES = 'Alle trin';
